/**
 * The Firebase web config for `larder-ca6b4`.
 *
 * THESE VALUES ARE NOT SECRET, and committing them is the documented, intended
 * practice. Every one of them ships inside the client bundle the moment the app
 * is served — a browser has to know which project to talk to. `apiKey` here is
 * a project identifier for the Firebase APIs, not an authorisation: it grants
 * nothing on its own.
 *
 * What actually protects the data is `firestore.rules`, which has 21 tests
 * (docs/decisions/0008-rules-are-tested-code.md). The one real secret in this
 * product is the Anthropic key, and it lives only in `functions/`, as a Cloud
 * Functions secret — see docs/engineering/deploy.md.
 *
 * Overridable by `VITE_FIREBASE_*` env vars so a fork or a second environment
 * does not have to edit source.
 */
export const firebaseConfig = {
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ?? "AIzaSyCes2t1hi7B1_oAeE_-h9W73jygrW3oKhg",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "larder-ca6b4.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "larder-ca6b4",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "larder-ca6b4.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "13234898532",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ?? "1:13234898532:web:1d5d13796d9737a000c171",
};
